// --------------------------------------------------------------
// Created On: 2021-08-23
// Author: Zachary Thomas
//
// Last Modified: 2025-11-03
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import Card from "../../components/Card/Card";
import TextBlurb from "../../components/TextBlurb/TextBlurb";
import styles from "./ErrorOutdatedMobilePage.module.scss";

// Page for displaying an error to the user about them being on an old version of the mobile app.
export default function ErrorOutdatedMobilePage(): Component {
  return (
    <div className={`${styles.body} p-4`} data-test="outdated-mobile-error-card">
      <Card title="Outdated Mobile App">
        <div className="my-5">
          <TextBlurb
            title="Please Upgrade App"
            paragraph={
              "You are currently using an outdated version of the mobile app " +
              "and cannot proceed until it is on the latest version."
            }
            icon="exclamation-triangle"
          />
        </div>
      </Card>
    </div>
  );
}
